import { render, staticRenderFns } from "./babyTicketDetails.vue?vue&type=template&id=6468508c&scoped=true&"
import script from "./babyTicketDetails.vue?vue&type=script&lang=js&"
export * from "./babyTicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./babyTicketDetails.vue?vue&type=style&index=0&id=6468508c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6468508c",
  null
  
)

export default component.exports